import { useAuth } from '@auth/AuthContext';
import { useGetMyMembershipQuery } from '@api/endpoints/onboardingApi';

/**
 * Identifies users who are acting as a provider (have a provider mapping)
 * but do NOT have elevated roles (practice-owner or medrender-owner).
 *
 * These users should only see their own provider scorecard and have
 * a restricted navigation experience.
 */
export function useProviderUser(): {
  isProviderUser: boolean;
  providerMapping: string | null;
  isLoading: boolean;
} {
  const { user } = useAuth();
  const { data, isLoading } = useGetMyMembershipQuery();

  const providerMapping = data?.membership?.providerMapping ?? null;
  const isElevated =
    (user?.groups?.includes('practice-owner') ?? false) ||
    (user?.groups?.includes('medrender-owner') ?? false);

  const isProviderUser = !!providerMapping && !isElevated;

  return { isProviderUser, providerMapping, isLoading };
}
